<div class="container-scroller content-wrapper">
  <div class="d-flex col-lg-11 mx-auto central-main mt-2">
    <img class="header-logo cursor-pointer" routerLink="/home" src="assets/svg/logo.svg" alt="header logo">
  </div>
  <div class="container-fluid page-body-wrapper full-page-wrapper">
    <div class="content-wrapper d-flex align-items-center auth px-0">
      <div class="row w-100 mx-0">
        <div class="mx-auto">
          <div class="auth-form-light text-left py-5 px-4 px-sm-5">
            <h4 class="password-reset-title"
                [ngClass]="{'password-reset-title-am': currentLang === Language.HY}">{{ 'forgot_password_content.password_reset' | translate }}</h4>
            <h6 class="font-weight-light">{{ 'forgot_password_content.description' | translate }}
              <br>{{ 'forgot_password_content.description1' | translate }}</h6>
            <form [formGroup]="form" (ngSubmit)="sendResetLink()"
                  (keydown.enter)="$event.preventDefault(); forgotButton.focus(); forgotButton.click()" method="post"
                  class="pt-3">
              <div class="form-group">
                <input id="email" type="text" name="email" formControlName="email"
                       placeholder="{{'login_content.email' | translate}}"
                       class="form-control form-control-lg"
                       [ngClass]="{'has-error': loginFormControl['email'].invalid && loginFormControl['email'].touched}"
                       (click)="resetErrorMessage()"/>
                @if (loginFormControl['email'].invalid && loginFormControl['email'].touched) {
                  <div class="validation">
                    @if (loginFormControl['email'].errors?.['required']) {
                      <small>{{ 'login_content.enter_email' | translate }}</small>
                    }
                    @if (loginFormControl['email'].errors?.['pattern']) {
                      <small>{{ 'login_content.valid_email' | translate }}</small>
                    }
                  </div>
                }
                @if (loginError) {
                  <div class="validation mt-2">{{ 'forgot_password_content.account_not_found' | translate }}</div>
                }
              </div>
              <div class="mt-3">
                <button class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn" type="submit"
                        [disabled]="form.invalid"
                        #forgotButton>{{ 'forgot_password_content.submit' | translate }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
